import { useSidebar } from "@dune/ui";
import { useEffect } from "react";
import { useCurrentPanel } from "../stores/panel.store";

export const usePanelSidebarIntegration = () => {
	const { setOpen, isMobile } = useSidebar();
	const currentPanel = useCurrentPanel();

	useEffect(() => {
		if (!isMobile && currentPanel) {
			setOpen(false);
		}
	}, [currentPanel, setOpen, isMobile]);
};
